// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"289":"5e198049","323":"a22ad0a8","363":"87b9733e","482":"e8103a10","511":"c1423207","703":"141934cc","798":"ce5eb9ce","813":"e3bb4d46","923":"05af254b","951":"cbdb7e3d"}[chunkId] + ".chunk.js";
};